import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetOverlay,
  SheetPortal,
} from '@design-system/Sheet';
import { Skeleton } from '@design-system/Skeleton';

interface OrderTrackingSkeletonProps {
  isOpen: boolean;
  onClose: () => void;
}

export const OrderTrackingSkeleton = ({
  isOpen,
  onClose,
}: OrderTrackingSkeletonProps) => (
  <Sheet open={isOpen} onOpenChange={onClose} data-testid="orderTrackingSkeleton-modal">
    <SheetPortal>
      <SheetOverlay data-testid="orderTrackingSkeleton-overlay" />
      <SheetContent
        side="right"
        className="w-full pr-0 pl-4"
        variant="glass"
        data-testid="orderTrackingSkeleton-content"
      >
        <SheetHeader data-testid="orderTrackingSkeleton-header">
          <div className="space-y-4">
            <Skeleton className="h-8 w-48" />
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-40" />
            {[...Array(9)].map((_, i) => (
              <Skeleton key={i} className="h-16 w-full mt-4" />
            ))}
          </div>
        </SheetHeader>
      </SheetContent>
    </SheetPortal>
  </Sheet>
);
